import React, { Component } from 'react'
import SelectApplet from '../../components/useful/SelectApplet'
import DriveViewType from '../../components/header/DriveViewType'
import DriveStyle from './DriveStyle'
import DriveSort from './DriveSort'
import DriveNew from './DriveNew'
import DriveOptions from './DriveOptions'
import FrameSettingMenu from '../../components/header/FrameSettingMenu'

export default class DriveToolbar extends Component {

    state = {}

    componentDidMount() {
        // console.log("componentDidMount !!!!!")
    }

    componentDidUpdate = (prevProps) => {
        // if (prevProps.data != this.props.data) { }
    }

    openSelectAppletModal = () => {
        this.selectApplet.appletViewModal.open()
    }

    render() {
        return (
            <div className='w-100 flexc '>
                {/* {!this.props.isApplet &&
                    <SelectApplet type='Drive' ref={el => this.selectApplet = el} setData={this.props.setCurrentApplet} setDataMain={this.props.setData} currentAppletName={this.props.currentAppletName} currentApplet={this.props.currentApplet} changeFrame={this.props.changeFrame} driveSections={this.props.driveSections} />
                } */}
                <DriveViewType language={this.props.language} width={this.props.width} changeFrame={this.props.changeFrame} frame={this.props.frame} functionsHandler={this.props.functionsHandler} driveSections={this.props.driveSections} viewType={this.props.viewType} />
                <DriveNew colors={this.props.colors} language={this.props.language} width={this.props.width} functionsHandler={this.props.functionsHandler} currentApplet={this.props.currentApplet} setData={this.props.setData} openTemplatesModal={this.props.openTemplatesModal} changePage={this.props.changePage} openSelectAppletModal={this.openSelectAppletModal} openNote={this.props.openNote} createDoc={this.props.createDoc} applet={this.props.applet} />
                <DriveSort colors={this.props.colors} language={this.props.language} width={this.props.width} sortList={this.props.sortList} currentSort={this.props.currentSort} isLoading={this.props.isLoading} />
                <DriveStyle colors={this.props.colors} language={this.props.language} width={this.props.width} setStateProps={this.props.setStateProps} isLoading={this.props.isLoading} />
                <FrameSettingMenu permissions={this.props.permissions} colors={this.props.colors} frame={this.props.frame} language={this.props.language} width={this.props.width} functionsHandler={this.props.functionsHandler} headers={this.props.headers} view={this.props.view} isMobile={this.props.isMobile} />

                {/* <DriveOptions colors={this.props.colors} language={this.props.language} width={this.props.width} /> */}
            </div>
        )
    }
}
